var exports = {
  "k": "x31de4314--2446a0--container",
};

module.exports = exports;
